import React, { useRef, useState } from 'react';
import styles from './css/index.module.scss';
import IconButton from '../../../../components/IconButton';
import ClipboardIcon from '../../../../assets/icons/clipboard.svg';
import ClipboardCopiedIcon from '../../../../assets/icons/clipboard_copied.svg';
import sleep from '../../../../helpers/sleep';
import MyButton from '../../../../components/MyButton';
import EmptyHeight from '../../../../components/EmptyHeight';
import convertPrice from '../../../../helpers/convertPrice';
import PasswordServices from '../../../../services/PasswordServices';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';

function SuccessTransactionModal({
  receiverWallet, transactionLink, offerCount, username, price,
}) {
  const { t } = useTranslations();
  const [isCopied, setIsCopied] = useState(false);
  const [clickedCount, setClickedCount] = useState(0);

  const getPayUrl = () => {
    const hash = PasswordServices.encryptPassword(JSON.stringify({
      createdAt: new Date(),
      tonAmount: price,
      recipientWallet: receiverWallet,
      expirationHours: 2,
    }));

    return `${window.location.origin}/transaction/pay.cryptomus.com/${hash}`;
  };

  const onCopyClick = async () => {
    setIsCopied(true);
    const url = getPayUrl();
    await navigator.clipboard.writeText(url);
    await sleep(1000);
    setIsCopied(false);
  };

  const onButtonClick = () => {
    const url = getPayUrl();
    window.open(url, '_blank');
  };

  return (
    <div className={styles.modalWrapper}>
      <p className={styles.title}>{t(DICTIONARY.transactionCreated)}</p>
      <EmptyHeight height={20} />
      <p className={styles.info}>{t(DICTIONARY.nowYouCanTransfer)}</p>
      <EmptyHeight height={30} />
      <div className={styles.table}>
        <div className={styles.tableRow}>
          <span className={styles.firstSpan}>{t(DICTIONARY.username).toLowerCase()}</span>
          <span className={styles.secondSpan}>
            @
            {username}
          </span>
        </div>
        <div className={styles.tableRow}>
          <span className={styles.firstSpan}>{t(DICTIONARY.price)}</span>
          <span className={styles.secondSpan}>
            {convertPrice(price)}
            {' '}
            TON
          </span>
        </div>
        <div className={styles.tableRow}>
          <span className={styles.firstSpan}>{t(DICTIONARY.attemptsCount)}</span>
          <span className={styles.secondSpan}>
            {offerCount}
            {' '}
            attempts
          </span>
        </div>
      </div>
      <EmptyHeight height={35} />
      <div className={styles.modalButtonsRow}>
        <IconButton svgPath={isCopied ? ClipboardCopiedIcon : ClipboardIcon} onClick={onCopyClick} />
        <MyButton text={t(DICTIONARY.transfer)} className={styles.button} onClick={onButtonClick} />
      </div>
    </div>
  );
}

export default SuccessTransactionModal;
